import { AllocationViewActionIdentifierModel, AllocationViewSealPictureControlModel } from '../../models';

export class AllocationViewPerformSealPictureControlAction {
  public static readonly type = '[AllocationViewPerformSealPictureControlAction] Seal Picture Control';

  constructor(public data: AllocationViewSealPictureControlModel) {}
}

export class AllocationViewPerformSealPictureControlActionPrepare {
  public static readonly type = '[AllocationViewPerformSealPictureControlAction] Seal Picture Control Prepare';

  constructor(public identifier: AllocationViewActionIdentifierModel, public language: string) {}
}

export class AllocationViewPerformSealPictureControlActionSetInitialState {
  public static readonly type = '[AllocationViewPerformSealPictureControlAction] Set Initial State';
}
